export default __webpack_public_path__ + "static/media/1.18e2cf4b.jpeg";